import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import UserRobot1 from "../../assets/user-image-plc/User_Robot_1.svg";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import rightArrowImg from "../../assets/right-arrow.svg";
import * as url from "../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  groupPrivacyStatusDesc,
  genderMapOptions,
  GENDER_PRONOUNS_OPTIONS,
  GENDER_PRONOUNS_MAP,
  removePhraseBetweenCommas,
  profilePicValidityCheck,
  isTrivvyProduct,
  manageRoleText,
  isTrivvyUrl,
  formatPhoneNumber,
} from "../../utils/constants";
import { toolkitCategories } from "../../utils/categories";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Row,
  Label,
  Col,
  Input,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
} from "reactstrap";
import "./ProfilePage.css";
import "./profile-bwai.css";
import { isMobile } from "../../utils/deviceInfo";
import UserIcon3 from "../../assets/user-image-plc/User_Icon_3.svg";
// import Maps from '../../components/Geolocate/Maps'
import TooltipDefinition from "../../components/UI/TooltipDefinition/TooltipDefinition";
import ProfileAbout from "./ProfileAbout";
import ProfileEvents from "./ProfileEvents";
import ProfileGroups from "./ProfileGroups";
import AutocompleteAddress from "../../components/AddressSearch/AutocompleteAddress";
import ProfileMetrics from "./ProfileMetrics";
import {
  BiCheck,
  BiCheckCircle,
  BiMailSend,
  BiSolidSave,
  BiXCircle,
} from "react-icons/bi";
import MyTrivia from "../trivia/MyTrivia";
import MyPendingTrivvys from "../trivia/MyPendingTrivvys";
import MyKnowledgeChecks from "../trivia/MyKnowledgeChecks";
import MyMessages from "../../components/MyMessages/MyMessages";
import PhoneInput from "react-phone-number-input";
import { BsCheck2Circle, BsCheckCircle } from "react-icons/bs";
import { LuBadgeCheck, LuSettings, LuX } from "react-icons/lu";
import { MdOutlineMobileFriendly } from "react-icons/md";
import NotificationPrefsComponent from "./UserProfile/NotificationPrefsComponent";

const diversity_array = [
  "dIRole",
  "gender",
  "ethnicity",
  "sexualOrientation",
  "religion",
  "veteran",
  "disability",
];
const technical_array = ["occupation", "seniority"];

class Profile extends Component {
  constructor(props) {
    super(props);
    let currentUser =
      this.props.member && this.props.member._id
        ? this.props.member
        : this.props.match.url.indexOf("home/profile") > -1 ||
          this.props.location.pathname.indexOf("home/profile") > -1
        ? this.props.user.profile
        : {};

    // currentUser:this.props.member && this.props.member._id?this.props.member : this.props.user.profile,
    // let currentUser = this.props.member

    let genderPronounOpenForce = false;

    const urlParams = new URLSearchParams(this.props.location.search);
    const myParam = urlParams.get("redirectParam");

    if (myParam == "edit_popup") {
      genderPronounOpenForce = true;
    }

    this.state = {
      menu: this.props.menu ? this.props.menu : 0,
      dontLoad: false,
      currentUser:
        this.props.member && this.props.member._id ? this.props.member : null,
      // currentUser:this.props.member,
      isGeoInput: false,
      member_user: this.props.member,
      currentProfile: null,
      geolocate: {},
      showEditProfileInfoModal: genderPronounOpenForce,
      pendingSurveysCount: 0,
      pendingKnowledgeChecksCount: 0,

      firstName: {
        value: currentUser.firstName || "",
        updatedValue: currentUser.firstName || "",
        error: false,
      },
      lastName: {
        value: currentUser.lastName || "",
        updatedValue: currentUser.lastName || "",
        error: false,
      },
      mobileNumber: {
        value: currentUser.mobileNumber || "",
        updatedValue: currentUser.mobileNumber || "",
        error: false,
      },
      email: {
        value: currentUser.email || "",
        updatedValue: currentUser.email || "",
        error: false,
      },
      employeeId: {
        value: currentUser.employeeId || "",
        updatedValue: currentUser.employeeId || "",
        error: false,
      },
      title: {
        value: currentUser.title || "",
        updatedValue: currentUser.title || "",
        error: false,
      },
      dIRole: {
        value: currentUser.dIRole || "",
        updatedValue: currentUser.dIRole || "",
      },
      gender: {
        value:
          currentUser.gender && currentUser.gender.reference
            ? currentUser.gender.reference
            : null,
        options: genderMapOptions.filter((e) => e.label !== "All"),
        updatedValue:
          currentUser.gender && currentUser.gender.reference
            ? currentUser.gender.reference
            : null,
      },
      ethnicity: {
        value:
          currentUser.ethnicity && currentUser.ethnicity.reference
            ? currentUser.ethnicity.reference
            : null,
        options: [],
        updatedValue:
          currentUser.ethnicity && currentUser.ethnicity.reference
            ? currentUser.ethnicity.reference
            : null,
      },
      occupation: {
        value:
          currentUser.occupation && currentUser.occupation.reference
            ? currentUser.occupation.reference
            : null,
        options: [],
        updatedValue:
          currentUser.occupation && currentUser.occupation.reference
            ? currentUser.occupation.reference
            : null,
      },
      seniority: {
        value:
          currentUser.seniority && currentUser.seniority.reference
            ? currentUser.seniority.reference
            : null,
        options: [],
        updatedValue:
          currentUser.seniority && currentUser.seniority.reference
            ? currentUser.seniority.reference
            : null,
      },
      sexualOrientation: {
        value:
          currentUser.sexualOrientation &&
          currentUser.sexualOrientation.reference
            ? currentUser.sexualOrientation.reference
            : null,
        options: [],
        updatedValue:
          currentUser.sexualOrientation &&
          currentUser.sexualOrientation.reference
            ? currentUser.sexualOrientation.reference
            : null,
      },
      veteran: {
        value:
          currentUser.veteran && currentUser.veteran.reference
            ? currentUser.veteran.reference
            : null,
        options: [],
        updatedValue:
          currentUser.veteran && currentUser.veteran.reference
            ? currentUser.veteran.reference
            : null,
      },
      disability: {
        value:
          currentUser.disability && currentUser.disability.reference
            ? currentUser.disability.reference
            : null,
        options: [],
        updatedValue:
          currentUser.disability && currentUser.disability.reference
            ? currentUser.disability.reference
            : null,
      },
      religion: {
        value:
          currentUser.religion && currentUser.religion.reference
            ? currentUser.religion.reference
            : null,
        options: [],
        updatedValue:
          currentUser.religion && currentUser.religion.reference
            ? currentUser.religion.reference
            : null,
      },
      birthDate: {
        value: currentUser.birthDate ? currentUser.birthDate : null,
        updatedValue: currentUser.birthDate ? currentUser.birthDate : null,
      },
      profilePic: {
        value: profilePicValidityCheck(currentUser.profilePic)
          ? currentUser.profilePic
          : null,
        updatedValue: profilePicValidityCheck(currentUser.profilePic)
          ? currentUser.profilePic
          : null,
        error: false,
      },
      profileBgImg: {
        value: currentUser.profileBgImg || undefined,
        updatedValue: currentUser.profileBgImg || undefined,
        error: false,
      },
      address: {
        value: currentUser.address || undefined,
        updatedValue: currentUser.address || undefined,
        error: false,
      },
      location: {
        value: currentUser.location || undefined,
        updatedValue: currentUser.location || undefined,
        error: false,
      },
      genderPronoun: {
        value:
          currentUser.genderPronoun >= 0
            ? currentUser.genderPronoun
            : undefined,
        updatedValue:
          currentUser.genderPronoun >= 0
            ? currentUser.genderPronoun
            : undefined,
        error: false,
      },
      addLocationToggle: false,
      addPhoneNumberToggle: false,
    };
    this.timer = null;
    if (Object.keys(currentUser).length == 0) {
      let id = this.props.match.params.id;
      let org = this.props.match.params.orgId;
      this.getUserDetails(id, org);
    }
  }

  componentWillUnmount = () => {
    this.props.updateNavBar({
      backButtonData: {
        show: false,
        currentPageType: "",
      },
    });
  };

  fetchPendingCounts = () => {
    axios
      .get(`${url.getMyPendingTrivvys}?includeAll=true`)
      .then(({ data }) => {
        const trivvysData = data.data || [];

        // Filter for surveys (uploadType == null && !isMessaging)
        const surveyData = trivvysData.filter(
          (e) => e.triviaId && e.triviaId.triviaCategoryType === "SURVEY" && !e.isMessaging
        );
        const pendingSurveysCount = surveyData.filter((e) => e.isPending).length || 0;

        // Filter for knowledge checks (uploadType != null && !isMessaging)
        const knowledgeChecksData = trivvysData.filter(
          (e) => e.triviaId && e.triviaId.triviaCategoryType === "KNOWLEDGE_CHECK"  && !e.isMessaging
        );
        const pendingKnowledgeChecksCount = knowledgeChecksData.filter((e) => e.isPending).length || 0;

        // Update component state with fresh counts
        this.setState({
          pendingSurveysCount,
          pendingKnowledgeChecksCount,
        });
      })
      .catch((err) => {
        console.log("Error fetching pending counts:", err);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevProps.location) !== JSON.stringify(this.props.location)
    ) {
      let current = this.props.location.pathname;
      let { menu } = prevState;

      if (!this.props.profilePopupMemberGrp) {
        if (
          (current.includes("groups") || current.includes("skills")) &&
          menu != 2
        ) {
          this.setState({ menu: 2 });
        } else if (current.includes("events") && menu != 3) {
          this.setState({ menu: 3 });
        } else if (current.includes("metrics") && menu != 4) {
          this.setState({ menu: 4 });
        }
        // else if (current.includes("my-trivvys") && menu != 5) {
        //   this.setState({ menu: 5 });
        // }
        //  else if (current.includes("pending-trivvys") && menu != 6) {
        //   this.setState({ menu: 6 });
        // }
         else if (current.includes("my-surveys") && menu != 6) {
          this.setState({ menu: 6 });
        }   else if (current.includes("my-knowledge-checks") && menu != 8) {
          this.setState({ menu: 8 });
        }
        else if (current.includes("my-messages") && menu != 7) {
          this.setState({ menu: 7 });
        } else if (
          ((!current.includes("events") &&
            !current.includes("metrics") &&
            // !current.includes("my-trivvys") &&
            !current.includes("my-messages") &&
            !current.includes("my-knowledge-checks") &&
            // !current.includes("pending-trivvys")) ||
             !current.includes("my-surveys")) ||

            current == "/home/profile") &&
          menu != 1
        ) {
          this.setState({ menu: 1 });
        }
      }
    }

    // console.log(menu,'------url --- ', current)
  }

  componentDidMount() {
    this.props.updateNavBar({
      backButtonData: {
        show: true,
        currentPageType: "OBJECTIVE_DETAILS",
      },
    });

    // Fetch pending counts for surveys and knowledge checks
    this.fetchPendingCounts();

    let religion = [],
      sexualOrientation = [],
      veteran = [],
      disability = [],
      ethnicity = [],
      seniority = [],
      occupation = [];
    let { currentUser, dontLoad } = this.state;
    let current = this.props.location.pathname;
    //
    // console.log('events change page----')
    let is_current = current.includes("/events") > -1 ? 3 : 1;

    let isAPIcall = false;
    if (!this.props.profilePopupMemberGrp) {
      if (current.includes("groups") || current.includes("skills")) {
        this.setState({ menu: 2 });
        isAPIcall = true;
      } else if (current.includes("events")) {
        this.setState({ menu: 3 });
      } else if (current.includes("metrics")) {
        this.setState({ menu: 4 });
      }
      // else if (current.includes("my-trivvys")) {
      //   this.setState({ menu: 5 });
      //   is_current = 5;
      // }
      //  else if (current.includes("pending-trivvys")) {
      //   is_current = 6;
      //   this.setState({ menu: 6 });
      // }
      else if (current.includes("my-surveys")) {
        is_current = 6;
        this.setState({ menu: 6 });
      }
      else if (current.includes("my-knowledge-checks")) {
        is_current = 8;
        this.setState({ menu: 8 });
      }
      else if (current.includes("my-messages")) {
        is_current = 7;
        this.setState({ menu: 7 });
      } else if (!current.includes("events")) {
        this.setState({ menu: 1 });
        isAPIcall = true;
      }
    }

    if (this.props.profilePopupMemberGrp) {
      isAPIcall = true;
    }

    if ((is_current == 1 || is_current == 2 || isAPIcall) && dontLoad != true) {
      axios.get(url.getDiversityTypes).then(({ data }) => {
        let resp = data.data;

        resp.map((e) => {
          if (e.categoryGrouping === "VETERAN") {
            veteran.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          } else if (e.categoryGrouping === "SEXUAL ORIENTATION") {
            sexualOrientation.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          } else if (e.categoryGrouping === "DISABILITY") {
            disability.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          } else if (e.categoryGrouping === "RELIGION") {
            religion.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          } else if (e.categoryGrouping === "ETHNICITY") {
            ethnicity.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          } else if (e.categoryGrouping === "SENIORITY") {
            if (e.name != "All") {
              seniority.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            }
          } else if (e.categoryGrouping === "OCCUPATION") {
            if (e.name != "All") {
              occupation.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            }
          }
        });
        this.setState((prevState) => ({
          ethnicity: { ...prevState.ethnicity, options: ethnicity },
          religion: { ...prevState.religion, options: religion },
          veteran: { ...prevState.veteran, options: veteran },
          disability: { ...prevState.disability, options: disability },
          sexualOrientation: {
            ...prevState.sexualOrientation,
            options: sexualOrientation,
          },
          occupation: { ...prevState.occupation, options: occupation },
          seniority: { ...prevState.seniority, options: seniority },
          dontLoad: true,
        }));
      });
    } else {
      this.setState({ menu: is_current });
    }

    if (currentUser == null) {
      let id = this.props.match.params.id;
      let org = this.props.match.params.orgId;
      this.getUserDetails(id, org);
    }
  }

  getUserDetails = (id, org) => {
    let that = this;
    let { user } = this.props;

    if (id == null || id == undefined) id = this.props.match.params.id;
    if (org == null || org == undefined) org = this.props.match.params.orgId;
    if (this.props.match.url.indexOf("home/profile") > -1) {
      id = this.props.user.profile._id;
    }
    // let id = this.props.match.params.id;
    // let org =this.props.match.params.orgId

    axios.get(url.getUserProfile(id, org)).then((response) => {
      let currentUser = response.data.data;

      if (currentUser.status == "INACTIVE") {
        this.props.history.push("/home/users");
      }
      that.setState({
        currentProfile: response.data.data,
        firstName: {
          value: currentUser.firstName || "",
          updatedValue: currentUser.firstName || "",
          error: false,
        },
        lastName: {
          value: currentUser.lastName || "",
          updatedValue: currentUser.lastName || "",
          error: false,
        },
        mobileNumber: {
          value: currentUser.mobileNumber || "",
          updatedValue: currentUser.mobileNumber || "",
          error: false,
        },
        email: {
          value: currentUser.email || "",
          updatedValue: currentUser.email || "",
          error: false,
        },
        employeeId: {
          value: currentUser.employeeId || "",
          updatedValue: currentUser.employeeId || "",
          error: false,
        },
        title: {
          value: currentUser.title || "",
          updatedValue: currentUser.title || "",
          error: false,
        },
        dIRole: {
          value: currentUser.dIRole || "",
          updatedValue: currentUser.dIRole || "",
        },
        gender: {
          value:
            currentUser.gender && currentUser.gender.reference
              ? currentUser.gender.reference
              : null,
          options: genderMapOptions.filter((e) => e.label !== "All"),
          updatedValue:
            currentUser.gender && currentUser.gender.reference
              ? currentUser.gender.reference
              : null,
        },
        ethnicity: {
          value:
            currentUser.ethnicity && currentUser.ethnicity.reference
              ? currentUser.ethnicity.reference
              : null,
          options: [],
          updatedValue:
            currentUser.ethnicity && currentUser.ethnicity.reference
              ? currentUser.ethnicity.reference
              : null,
        },
        occupation: {
          value:
            currentUser.occupation && currentUser.occupation.reference
              ? currentUser.occupation.reference
              : null,
          options: [],
          updatedValue:
            currentUser.occupation && currentUser.occupation.reference
              ? currentUser.occupation.reference
              : null,
        },
        seniority: {
          value:
            currentUser.seniority && currentUser.seniority.reference
              ? currentUser.seniority.reference
              : null,
          options: [],
          updatedValue:
            currentUser.seniority && currentUser.seniority.reference
              ? currentUser.seniority.reference
              : null,
        },
        sexualOrientation: {
          value:
            currentUser.sexualOrientation &&
            currentUser.sexualOrientation.reference
              ? currentUser.sexualOrientation.reference
              : null,
          options: [],
          updatedValue:
            currentUser.sexualOrientation &&
            currentUser.sexualOrientation.reference
              ? currentUser.sexualOrientation.reference
              : null,
        },
        veteran: {
          value:
            currentUser.veteran && currentUser.veteran.reference
              ? currentUser.veteran.reference
              : null,
          options: [],
          updatedValue:
            currentUser.veteran && currentUser.veteran.reference
              ? currentUser.veteran.reference
              : null,
        },
        disability: {
          value:
            currentUser.disability && currentUser.disability.reference
              ? currentUser.disability.reference
              : null,
          options: [],
          updatedValue:
            currentUser.disability && currentUser.disability.reference
              ? currentUser.disability.reference
              : null,
        },
        religion: {
          value:
            currentUser.religion && currentUser.religion.reference
              ? currentUser.religion.reference
              : null,
          options: [],
          updatedValue:
            currentUser.religion && currentUser.religion.reference
              ? currentUser.religion.reference
              : null,
        },
        birthDate: {
          value: currentUser.birthDate ? currentUser.birthDate : null,
          updatedValue: currentUser.birthDate ? currentUser.birthDate : null,
        },
        profilePic: {
          value: currentUser.profilePic || undefined,
          updatedValue: currentUser.profilePic || undefined,
          error: false,
        },
        profileBgImg: {
          value: currentUser.profileBgImg || undefined,
          updatedValue: currentUser.profileBgImg || undefined,
          error: false,
        },
      });
    });
  };

  showLabel = (div, memberDiv) => {
    // console.log('div 605---', div)
    if (div.options && div.options.length > 0) {
      if (div.updatedValue) {
        let obj = div.options.filter((e) => {
          if (e.value === div.updatedValue) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj && obj[0]?obj[0].label:null
      } else {
        return "N/A";
      }
    }
  };

  isOpenGeo = () => {
    let { isGeoInput } = this.state;
    this.setState({ isGeoInput: !isGeoInput });
  };

  setGeoText = ({ target }) => {
    const { value } = target;
    this.setState({ addressTxt: value });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  geolocate = () => {
    let payload = {
      geo: "test",
    };
    let that = this;
    // axios.post(url.geolocate, payload).then(({ data }) => {

    //   })
  };

  handleProfilePicUpload = (event) => {
    let profilePic = event.target.files[0];
    let profilePicExt = profilePic.name.split(".")[
      profilePic.name.split(".").length - 1
    ];
    let profilePicUrl = URL.createObjectURL(event.target.files[0]);
    if (!["png", "jpg", "jpeg"].includes(profilePicExt.toLowerCase())) {
      this.setState({
        profilePicUrl: undefined,
        profilePic: {
          value: this.props.user.profilePic,
          error: true,
          errorMessage: "Only .png and .jpg files are allowed.",
        },
      });
    } else if (profilePic.size > 1024 * 1024 * 2) {
      this.setState({
        profilePicUrl: undefined,
        profilePic: {
          value: this.props.user.profilePic,
          error: true,
          errorMessage: "Image size is more that 2MB",
        },
      });
    } else {
      this.setState({
        profilePic: {
          updatedValue: profilePic,
          value: this.props.user.profilePic,
          profilePicUrl: profilePicUrl,
          error: false,
          errorMessage: "",
        },
      });
    }
  };

  diversityCheck = (diversity) => {
    if (diversity && diversity.reference) {
      return diversity.reference;
    } else {
      return null;
    }
  };

  showGenderLabel = (gender) => {
    if (gender.options) {
      let val = gender.updatedValue;
      let res = gender.options.filter((e) => {
        if (e.value === val) {
          return {
            value: e.value,
            label: e.label,
          };
        }
      });
      return res[0];
    }
  };

  grabLabel = (div) => {
    if (div && div.updatedValue) {
      let val = div.updatedValue;
      let obj = div.options.filter((e) => {
        if (e.value === val) {
          return {
            value: e.value,
            label: e.label,
          };
        }
      });
      return obj[0];
    } else {
      return null;
    }
  };

  handleEditProfileInfo = () => {
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g;

    let {
      firstName,
      lastName,
      title,
      dIRole,
      profilePic,
      birthDate,
      gender,
      occupation,
      seniority,
      ethnicity,
      religion,
      sexualOrientation,
      disability,
      veteran,
      address,
      location,
      genderPronoun,
      mobileNumber,
      email,
      employeeId,
      currentUser,
    } = { ...this.state };
    if (
      firstName.updatedValue.trim() !== "" &&
      specialChar.test(firstName.updatedValue)
    ) {
      this.setState({
        firstName: {
          updatedValue: firstName.updatedValue,
          value: firstName.value,
          error: true,
          errorMessage: "Please remove any numbers or special characters.",
        },
      });
    } else if (
      lastName.updatedValue.trim() !== "" &&
      specialChar.test(lastName.updatedValue)
    ) {
      this.setState({
        lastName: {
          updatedValue: lastName.updatedValue,
          value: lastName.value,
          error: true,
          errorMessage: "Please remove any numbers or special characters.",
        },
      });
    } 
    // else if (title.updatedValue.trim() === "") {
    //   this.setState({
    //     title: {
    //       updatedValue: "",
    //       value: title.value,
    //       error: true,
    //       errorMessage: "Please enter your title.",
    //     },
    //   });
    // } 
    else {
      let formData = new FormData();
      formData.append("firstName", firstName.updatedValue);
      formData.append('userId', currentUser._id);
      formData.append("mobileNumber", mobileNumber.updatedValue);
      formData.append("lastName", lastName.updatedValue);
      formData.append("email", email.updatedValue);
      formData.append("employeeId", employeeId.updatedValue);
      formData.append("ethnicity", JSON.stringify(this.grabLabel(ethnicity)));
      formData.append("religion", JSON.stringify(this.grabLabel(religion)));
      formData.append(
        "sexualOrientation",
        JSON.stringify(this.grabLabel(sexualOrientation))
      );
      formData.append("disability", JSON.stringify(this.grabLabel(disability)));
      formData.append("seniority", JSON.stringify(this.grabLabel(seniority)));
      formData.append("occupation", JSON.stringify(this.grabLabel(occupation)));
      formData.append("veteran", JSON.stringify(this.grabLabel(veteran)));
      formData.append("gender", JSON.stringify(this.grabLabel(gender)));
      formData.append("title", title.updatedValue || null);
      formData.append("dIRole", dIRole.updatedValue);
      formData.append("birthDate", birthDate.updatedValue);
      if (profilePic.updatedValue && typeof profilePic.updatedValue !== 'string') {
        formData.append("profilePic", profilePic.updatedValue);
      }
      formData.append("address", address.updatedValue);
      formData.append("location", JSON.stringify(location.updatedValue));
      formData.append("genderPronoun", genderPronoun.updatedValue);

      axios
        .put(url.editProfileInfo, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let profile_res = response.data.data;

          // Only update the Redux store if the logged-in user is editing their own profile
          // Don't update when an admin is editing another user's profile
          if (currentUser && currentUser._id === this.props.user.profile._id) {
            this.props.onProfileUpdate(profile_res);
          }

          let {
            firstName,
            lastName,
            title,
            dIRole,
            profilePic,
            gender,
            ethnicity,
            religion,
            veteran,
            sexualOrientation,
            occupation,
            seniority,
            disability,
            birthDate,
            mobileNumber,
            email,
            employeeId,
          } = profile_res;

          this.setState((prevState) => ({
            currentProfile: { ...(prevState.currentProfile || this.props.member || {}), ...profile_res },
            addPhoneNumberToggle: false,
            showEditProfileInfoModal: false,
            firstName: { value: firstName, updatedValue: firstName },
            mobileNumber: { value: mobileNumber, updatedValue: mobileNumber },
            lastName: { value: lastName, updatedValue: lastName },
            email: { value: email, updatedValue: email },
            employeeId: { value: employeeId, updatedValue: employeeId },
            title: { value: title, updatedValue: title },
            dIRole: { value: dIRole, updatedValue: dIRole },
            profilePic: { value: profilePic, updatedValue: profilePic },
            gender: {
              ...prevState.gender,
              updatedValue: this.diversityCheck(gender),
              value: this.diversityCheck(gender),
            },
            ethnicity: {
              ...prevState.ethnicity,
              updatedValue: this.diversityCheck(ethnicity),
              value: this.diversityCheck(ethnicity),
            },
            religion: {
              ...prevState.religion,
              updatedValue: this.diversityCheck(religion),
              value: this.diversityCheck(religion),
            },
            veteran: {
              ...prevState.veteran,
              updatedValue: this.diversityCheck(veteran),
              value: this.diversityCheck(veteran),
            },
            disability: {
              ...prevState.disability,
              updatedValue: this.diversityCheck(disability),
              value: this.diversityCheck(disability),
            },
            sexualOrientation: {
              ...prevState.sexualOrientation,
              updatedValue: this.diversityCheck(sexualOrientation),
              value: this.diversityCheck(sexualOrientation),
            },
            occupation: {
              ...prevState.occupation,
              updatedValue: this.diversityCheck(occupation),
              value: this.diversityCheck(occupation),
            },
            seniority: {
              ...prevState.seniority,
              updatedValue: this.diversityCheck(seniority),
              value: this.diversityCheck(seniority),
            },
            birthDate: {
              ...prevState.birthDate,
              updatedValue: birthDate,
              value: birthDate,
            },
          }));
        })
        .catch((error) => {
          console.log("test---", error);
          this.setState({
            error: true,
            // errorMessage: error.response.data.errors.message
          });
        });
    }
  };

  saveMobileNumber = () => {
    axios
      .put(url.changeMobileNumber(this.state.currentUser._id), {
        mobileNumber: this.state.mobileNumber.updatedValue || "",
      })
      .then((data) => {
        this.setState({
          addPhoneNumberToggle: false,
        });
      })
      .catch((error) => {
        this.setState({
          addPhoneNumberToggle: false,
        });
      });
  };

  updateDiversity = (value, obj) => {
    if (value && value.value) {
      obj["updatedValue"] = value.value;
      this.setState({ obj });
    } else {
      obj["updatedValue"] = null;
      this.setState({ obj });
    }
  };

  handleDateChange = (date) => {
    if (date) {
      this.setState({ birthDate: { updatedValue: moment(date) } });
    } else {
      this.setState({ birthDate: { updatedValue: null } });
    }
  };

  diversityValue = (div, userDiv) => {
    // console.log(div, userDiv)
    if (div.options) {
      if (div.updatedValue && (div.updatedValue.value || div.updatedValue)) {
        let val = div.updatedValue ? div.updatedValue : div.updatedValue.value;
        let obj = div.options.filter((e) => {
          if (e.value === val) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj[0];
      } else if (userDiv && userDiv.reference) {
        let obj = div.options.filter((e) => {
          if (e.value === userDiv.reference) {
            return { value: e.value, label: e.label };
          }
        });

        return obj[0];
      }
    } else {
      return null;
    }
  };

  nameCheck = (e) => {
    let value = e
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "")
      .replace(/^\n|\n$/g, "");
  };

  renderFieldOptions = (option) => {
    let target = `${option.value}${this.props.label}`;
    return (
      <TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.label}
        type="light"
        place="left"
        delayShow={500}
      />
    );
  };

  renderProfileDiversity = () => {
    let res = [];
    let state = this.state;
    diversity_array.map((e) => {
      if (
        state[e] &&
        state[e].updatedValue &&
        state[e].updatedValue != null &&
        state[e].updatedValue != ""
      ) {
        let user_val = this.showLabel(state[e]);
        if (user_val != undefined && user_val != null) {
          res.push(user_val);
        }
      }
    });

    return res.length ? "| " + res.join(" | ") : "";
  };

  renderProfileFunctional = () => {
    let res = [];
    let state = this.state;
    technical_array.map((e) => {
      if (
        state[e] &&
        state[e].updatedValue &&
        state[e].updatedValue != null &&
        state[e].updatedValue != ""
      ) {
        let user_val = this.showLabel(state[e]);
        if (user_val != undefined && user_val != null) {
          res.push(user_val);
        }
      }
    });

    return res.join(" | ");
  };

  selectMenu = (menu) => {
    //  let current_user_org =  this.props.member.organizationId,
    //  current_user_id = this.props.member._id
    if (!this.props.profilePopupMemberGrp) {
      let { currentUser } = this.state,
        { user, member } = this.props;

      let user_profile =
        currentUser && currentUser._id
          ? currentUser
          : member && member._id
          ? member
          : this.props.user.profile;

      this.setState({ menu });

      if (user_profile) {
        let orgId =
            typeof user_profile.organizationId == "object"
              ? user_profile.organizationId._id
              : user_profile.organizationId,
          baseUrl = `/home/${orgId}/profile/${user_profile._id}`,
          eventURL = baseUrl + "/events";

        // this.props.history.push('/events')
        // console.logU
        if (menu == 1) {
          // this.props.history.push(`/home/profile/`)
          this.props.history.push(baseUrl);
        } else if (menu == 2) {
          // this.props.history.push(`/home/profile/groups`)
        } else if (menu == 3) {
          // this.props.history.push(`/home/profile/events`)
          this.props.history.push(eventURL);
        } else if (menu == 4) {
          // this.props.history.push(`/home/profile/events`)
          this.props.history.push(baseUrl + "/metrics");
        } 
        // else if (menu == 5) {
        //   // this.props.history.push(`/home/profile/events`)
        //   this.props.history.push(baseUrl + "/my-trivvys");
        // } 
        // else if (menu == 6) {
        //   // this.props.history.push(`/home/profile/events`)
        //   this.props.history.push(baseUrl + "/pending-trivvys");
        // } 
         else if (menu == 6) {
          // this.props.history.push(`/home/profile/events`)
          this.props.history.push(baseUrl + "/my-surveys");
        } 
        else if (menu == 7) {
          // this.props.history.push(`/home/profile/events`)
          this.props.history.push(baseUrl + "/my-messages");
        }  
        else if (menu == 8) {
          this.props.history.push(baseUrl + "/my-knowledge-checks");
        }
      }
    } else {
      this.setState({ menu });
    }
  };

  profileEditSuccsess = (data) => {
    // this.props.profileEditSuccsess(data);
    this.props.onProfileUpdate(data);
  };

  renderProfileMenuContent = () => {
    let { menu, currentProfile } = this.state;
    let member =
      currentProfile && currentProfile._id
        ? currentProfile
        : this.props.member && this.props.member._id
          ? this.props.member
          : null;
    if (member && member._id) {
      if (menu == 1) {
        return (
          <ProfileAbout
            member={member}
            currentUser={member}
            profileEditSuccsess={this.profileEditSuccsess}
            organization={this.props.user.profile.organizationId}
            isTrivvyUrl={isTrivvyUrl()}
          />
        );
      } else if (menu == 2) {
        return (
          <ProfileGroups currentUser={member} member={member} {...this.state} />
        );
      } else if (menu == 3) {
        return <ProfileEvents currentUser={member} member={member} />;
      } else if (menu == 4) {
        return (
          <ProfileMetrics
            currentUser={member}
            member={member}
            user={this.props.user}
          />
        );
      }
      // else if (menu == 4) {
      //   return <ProfileMetrics  currentUser={member} member={member}  /> ;
      // }
      else if (menu == 5) {
        return (
          <div className="d-block">
            <div>
              <MyTrivia {...this.props} />
            </div>{" "}
          </div>
        );
      } else if (menu == 6) {
        return <MyPendingTrivvys {...this.props} />;
      } else if (menu == 7) {
        return <MyMessages {...this.props} />;
      } else if (menu == 8) {
        return <MyKnowledgeChecks {...this.props} />;
      } 
    }
  };
  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  openProfileDetailsModal = () => {
    this.setState({ showEditProfileInfoModal: true });
  };

  closeEditProfileInfoModal = () => {
                    this.setState((state) => ({
                      showEditProfileInfoModal: !state.showEditProfileInfoModal,
                      firstName: {
                        value: state.firstName.value,
                        updatedValue: state.firstName.value,
                      },
                      lastName: {
                        value: state.lastName.value,
                        updatedValue: state.lastName.value,
                      },
                      mobileNumber: {
                        value: state.mobileNumber.value,
                        updatedValue: state.mobileNumber.value,
                      },
                      email: {
                        value: state.email.value,
                        updatedValue: state.email.value,
                      },
                      employeeId: {
                        value: state.employeeId.value,
                        updatedValue: state.employeeId.value,
                      },
                      title: {
                        value: state.title.value,
                        updatedValue: state.title.value,
                      },
                      dIRole: {
                        value: state.dIRole.value,
                        updatedValue: state.dIRole.value,
                      },
                      profilePic: {
                        value: state.profilePic.value,
                        updatedValue: state.profilePic.value,
                      },
                    }));
  };

  updateCurrentuser = (key, data) => {
    const userData = { ...this.state.currentUser };

    userData[key] = data;

    this.setState({ currentUser: userData });
  };

  renderProfile = () => {
    // let{member:user}=this.props
    let {
      firstName,
      lastName,
      title,
      dIRole,
      isOpenGeo,
      addressTxt,
      profileBgImg,
      currentUser,
      menu,
      showEditProfileInfoModal,
      profilePic,
      gender,
      occupation,
      seniority,
      religion,
      ethnicity,
      sexualOrientation,
      veteran,
      disability,
      birthDate,
      genderPronoun,
      address,
      mobileNumber,
      email,
      employeeId,
      addPhoneNumberToggle,
      currentProfile,
    } = this.state;

    let member =
      currentProfile && currentProfile._id
        ? currentProfile
        : this.props.member && this.props.member._id
          ? this.props.member
          : null;

    let isCurrentUser = currentUser && Object.keys(currentUser).length > 0;
    console.log("genderPronoun.updatedValue --- ", genderPronoun);

    const isTrivvyAccount =
      this.props.user.organizationId &&
      this.props.user.organizationId.isSignedUpFromTrivvyWebsite &&
      this.props.user.organizationId.isSignedUpFromTrivvyWebsite;
    const brandBannerStyle = whiteLabelStyling(
      ["backgroundColor"],
      this.props.user.profile.organizationId,
      false,
      true
    );
    const hasBanner = Boolean(profileBgImg.updatedValue) || Boolean(brandBannerStyle);

    return (
      <div className="content-profile-page bwai-profile">
        <div
          className={`profile-user-page card profile_page_margin bwai-profile-card${
            menu == 1 ? " bwai-profile-card--seam" : ""
          }`}
        >
          {hasBanner && (
            <div className="img-user-profile">
              {profileBgImg.updatedValue ? (
                <img className="profile-bgHome" src={profileBgImg.updatedValue} />
              ) : (
                <div
                  className="profile-bgHome"
                  style={whiteLabelStyling(
                    ["backgroundColor"],
                    this.props.user.profile.organizationId,
                    false,
                    true
                  )}
                ></div>
              )}
              {/* <img className="avatar" src={user.profilePic || UserIcon3} alt="jofpin"/> */}
            </div>
          )}

          <div className="profile_page_components_container_details">
            {profilePic && profilePicValidityCheck(profilePic.updatedValue) ? (
              <img
                className="avatar"
                src={profilePic.updatedValue || UserIcon3}
                alt="jofpin"
              />
            ) : (
              <span
                className="profile_page_components_container_details_initials"
                data-letters={
                  isCurrentUser ? this.getInitials(currentUser) : ""
                }
              ></span>
            )}

            <div className="user-profile-data" style={{display: 'flex', alignItems: 'center'}}>
              {currentUser && currentUser._id == this.props.user.profile._id ? (
                <span
                  className="profile_page_login_btn"
                  style={{ right: "9em", border: "none", padding: "0px" }}
                >
                  <NotificationPrefsComponent
                    member={member}
                    currentUser={this.state.currentUser}
                    profileEditSuccsess={this.profileEditSuccsess}
                    organization={this.props.user.profile.organizationId}
                    user={this.props.user}
                    updateCurrentuser={this.updateCurrentuser}
                  />
                </span>
              ) : (
                ""
              )}

              {/* Show Settings button only if: user is viewing their own profile OR user is an admin */}
              {(currentUser && currentUser._id == this.props.user.profile._id) || 
               this.props.user.profile.orgAdmin ? (
                <div
                  className="profile_page_login_btn _settings"
                  onClick={() => this.openProfileDetailsModal()}
                >
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <LuSettings size={16} />
                    <span>Settings</span>
                  </div>
                </div>
              ) : null}
              </div>
              <div className="profile_page_details_user_name">
                {firstName.updatedValue} {lastName.updatedValue}{" "}
                {genderPronoun.updatedValue !== null &&
                genderPronoun.updatedValue >= 0 ? (
                  <span className="description-profile gender-map ml-1">
                    ({GENDER_PRONOUNS_MAP[genderPronoun.updatedValue] || ""})
                  </span>
                ) : null}
                <span className="ml-1">
                  {currentUser.isPasswordChanged ? (
                    <span className="active-account-tag p-0">
                      <LuBadgeCheck size={16} className="mr-1" />
                    </span>
                  ) : currentUser.lastInvitedAt ? (
                    <span className="users_gp_members">
                      (last invited{" "}
                      {moment(currentUser.lastInvitedAt).format("MMM DD, YYYY")}{" "}
                      {currentUser.lastInviteVia &&
                      Array.isArray(currentUser.lastInviteVia) &&
                      currentUser.lastInviteVia.length ? (
                        <span className="ml-1" style={{ fontSize: "15px" }}>
                          {currentUser.lastInviteVia.includes("EMAIL") && (
                            <BiMailSend />
                          )}{" "}
                          {currentUser.lastInviteVia.includes("SMS") && (
                            <MdOutlineMobileFriendly />
                          )}
                        </span>
                      ) : (
                        ""
                      )}{" "}
                      ){" "}
                    </span>
                  ) : (
                    ""
                  )}
                </span>
              </div>
              {currentUser && currentUser.email ? (
                <div className="bwai-profile-email">{currentUser.email}</div>
              ) : null}
              {!isTrivvyUrl() && (
                <div>
                  {title.updatedValue}
                  <span className="description-profile">
                    {" "}
                    ({manageRoleText(currentUser)})
                  </span>
                  {/* {isCurrentUser
                  ? currentUser.orgAdmin
                    ? "(Admin)"
                    : currentUser.role
                  : ""} */}
                </div>
              )}
       

            {/* <div className="geolocate_profile_page">
                            {isOpenGeo?
                                <span>
                                    <input type="text" className="form-control"
                                    onChange={this.setGeoText} 
                                    value={addressTxt}
                                    autoComplete="off"  placeholder=''/>
                                    <span onClick={()=>this.isOpenGeo()}>Save</span>
                                    <span onClick={()=>this.isOpenGeo()}>Back</span>
                                </span>
                            :
                            <span onClick={()=>this.isOpenGeo()}> Add your location</span>
                            }
                    </div> */}

            {currentUser && currentUser._id == this.props.user.profile._id ? (
              <div className="description-profile">
                {this.renderProfileFunctional()} {this.renderProfileDiversity()}
              </div>
            ) : null}

            {/* {currentUser && currentUser._id == this.props.user.profile._id ? (
              <div className="description-profile">
               {this.renderProfileDiversity()}
              </div>
            ) : null} */}

            {/* {address.updatedValue ? ( */}
            {!isTrivvyUrl() && (
              <div className="description-profile">
                <span className="description-profile-key">Based in</span>:{" "}
                <span>
                  {removePhraseBetweenCommas(
                    address.updatedValue,
                    "CAL Fire"
                  ) ? (
                    removePhraseBetweenCommas(address.updatedValue, "CAL Fire")
                  ) : (
                    <span>
                      {currentUser &&
                      currentUser._id == this.props.user.profile._id ? (
                        <span>
                          {this.state.addLocationToggle ? (
                            <AutocompleteAddress
                              customClassName="search-input-profile-inline"
                              address={this.state.address.updatedValue}
                              handleSelect={(address, lng, lat) => {
                                this.setState(
                                  {
                                    address: {
                                      ...this.state.address,
                                      updatedValue: address,
                                    },
                                    addLocationToggle: false,
                                    location: {
                                      ...this.state.location,
                                      updatedValue: {
                                        type: "Point",
                                        coordinates: [lng, lat],
                                      },
                                    },
                                  },
                                  () => {
                                    this.handleEditProfileInfo();
                                  }
                                );
                              }}
                              relative
                              delayClose
                              closeComponent={
                                <BiXCircle
                                  size={20}
                                  className="ml-1 cursor-pointer"
                                  onClick={() => {
                                    this.setState({
                                      addLocationToggle: false,
                                    });
                                  }}
                                />
                              }
                              dropdownWidth={"40%"}
                            />
                          ) : (
                            <span
                              className="cursor-pointer"
                              onClick={() => {
                                this.setState({ addLocationToggle: true });
                              }}
                              style={{ color: "#3498db" }}
                            >
                              Add location here
                            </span>
                          )}
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </span>
                  )}
                </span>
              </div>
            )}
            {/* // ) : (
            //   ""
            // )} */}

            {/* <div
              className="description-profile"
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "",
                gap: isMobile ? "" : "2em",
              }}
            >
              <span>
                {" "}
                <span className="description-profile-key">Email</span>:{" "}
                {isCurrentUser ? currentUser.email : ""}
              </span>

              {(isCurrentUser &&
                currentUser._id == this.props.user.profile._id) ||
              this.props.user.profile.orgAdmin ? (
                <span>
                  <span className="description-profile-key">Mobile Number</span>
                  :{" "}
                  <span>
                    {addPhoneNumberToggle ? (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                      >
                        <span style={{ width: "300px" }}>
                          <PhoneInput
                            placeholder="Enter mobile number"
                            addInternationalOption={false}
                            value={mobileNumber.value}
                            onChange={(v) =>{
                            
                              this.setState({
                                mobileNumber: {
                                  value: v,
                                  updatedValue: formatPhoneNumber(v),
                                  error: false,
                                },
                              })
                            }
                            }
                            className="form-control p-0 pl-2"
                            defaultCountry="US"
                          />{" "}
                        </span>

                        <span style={{ color: "#0f6603" }}>
                          <BsCheckCircle
                            size={20}
                            color="success"
                            className="ml-1 mr-1 cursor-pointer"
                            onClick={() => {
                              this.saveMobileNumber();
                            }}
                          />{" "}
                        </span>

                        <BiXCircle
                          size={22}
                          className="ml-1 cursor-pointer"
                          color="#f23851"
                          onClick={() => {
                            this.setState({
                              addPhoneNumberToggle: false,
                            });
                          }}
                        />
                      </span>
                    ) : (
                      <span
                        onClick={() =>
                          this.setState({
                            addPhoneNumberToggle: true,
                          })
                        }
                        className="text-info cursor-pointer"
                      >
                        {isCurrentUser &&
                        profilePicValidityCheck(this.state.mobileNumber.value)
                          ? this.state.mobileNumber.value || "N/A"
                          : "N/A"}
                      </span>
                    )}
                  </span>
                </span>
              ) : (
                ""
              )} */}
            {/* <span className="description-profile-key ml10">Role</span>:{" "}
              {isCurrentUser
                ? currentUser.orgAdmin
                  ? "Enterprise Admin"
                  : currentUser.role
                : ""} */}
            {/* </div> */}
          </div>
          {/* isSignedUpFromTrivvyWebsite */}

          {isMobile ? (
            <div 
              style={{
                overflowX: "auto",
                overflowY: "hidden",
                WebkitOverflowScrolling: "touch",
                display: "block",
                whiteSpace: "nowrap",
                maxWidth: "100vw"
              }}
            >
              <ul 
                className="data-user bwai-profile-tabs--mobile"
                style={{ 
                  display: "inline-flex",
                  marginBottom: 0,
                  paddingRight: "20px"
                }}
              >
            <li>
              <a
                className={`${
                  menu == 1 ? "profile_page_menu_option_active" : ""
                }`}
                onClick={() => this.selectMenu(1)}
              >
                About
              </a>
            </li>
            {/* <li><a className={`${menu==2?'profile_page_menu_option_active':''}`} onClick={()=>this.selectMenu(2)}>Highlights
                      </a></li> */}

            {!isTrivvyUrl() && (
              <li>
                <a
                  className={`${
                    menu == 3 ? "profile_page_menu_option_active" : ""
                  }`}
                  onClick={() => this.selectMenu(3)}
                >
                  Events
                </a>
              </li>
            )}

            {!isTrivvyUrl() &&
            this.props.match &&
            this.props.match.params &&
            this.props.match.params.id &&
            this.props.user.profile._id === this.props.match.params.id ? (
              <li>
                <a
                  className={`${
                    menu == 4 ? "profile_page_menu_option_active" : ""
                  }`}
                  onClick={() => this.selectMenu(4)}
                >
                  Metrics
                </a>
              </li>
            ) : (
              ""
            )}

            {/* {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                <li>
                  <a
                    className={`${
                      menu == 5 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(5)}
                  >
                    My Trivvys
                  </a>
                </li>
              )} */}
            {/* {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                <li>
                  <a
                    className={`${
                      menu == 6 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(6)}
                  >
                    Pending Trivvys
                  </a>
                </li>
              )} */}


          {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
             <li  style={{ position: "relative" }}>
                  <a
                    className={`${
                      menu == 6 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(6)}
                  >
                    My Surveys 
                    {this.state.pendingSurveysCount > 0 && (
                      <span className="tab_count surveys_tab_count">
                        {this.state.pendingSurveysCount}
                      </span>
                    )}
                  </a>
                </li>
              )}


            {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                     <li  style={{ position: "relative" }}>
                  <a
                    className={`${
                      menu == 7 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(7)}
                  >
                    My Messages
                  </a> 
                </li>
              )}


            {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                <li  style={{ position: "relative" }}>
                  <a
                    className={`${
                      menu == 8 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(8)}
                  >
                    My Knowledge Checks
                       {this.state.pendingKnowledgeChecksCount > 0 && (
                        <span className="tab_count kcs_tab_count">
                          {this.state.pendingKnowledgeChecksCount}
                        </span>
                      )}
                  </a>
                </li>
              )}


          </ul>
            </div>
          ) : (
            <ul className="data-user bwai-profile-tabs">
            <li>
              <a
                className={`${
                  menu == 1 ? "profile_page_menu_option_active" : ""
                }`}
                onClick={() => this.selectMenu(1)}
              >
                About
              </a>
            </li>
            {/* <li><a className={`${menu==2?'profile_page_menu_option_active':''}`} onClick={()=>this.selectMenu(2)}>Highlights
                      </a></li> */}

            {!isTrivvyUrl() && (
              <li>
                <a
                  className={`${
                    menu == 3 ? "profile_page_menu_option_active" : ""
                  }`}
                  onClick={() => this.selectMenu(3)}
                >
                  Events
                </a>
              </li>
            )}

            {!isTrivvyUrl() &&
            this.props.match &&
            this.props.match.params &&
            this.props.match.params.id &&
            this.props.user.profile._id === this.props.match.params.id ? (
              <li>
                <a
                  className={`${
                    menu == 4 ? "profile_page_menu_option_active" : ""
                  }`}
                  onClick={() => this.selectMenu(4)}
                >
                  Metrics
                </a>
              </li>
            ) : (
              ""
            )}

            {/* {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                <li>
                  <a
                    className={`${
                      menu == 5 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(5)}
                  >
                    My Trivvys
                  </a>
                </li>
              )} */}
            {/* {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                <li>
                  <a
                    className={`${
                      menu == 6 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(6)}
                  >
                    Pending Trivvys
                  </a>
                </li>
              )} */}


          {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
             <li  style={{ position: "relative" }}>
                  <a
                    className={`${
                      menu == 6 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(6)}
                  >
                    My Surveys 
                    {this.state.pendingSurveysCount > 0 && (
                      <span className="tab_count surveys_tab_count">
                        {this.state.pendingSurveysCount}
                      </span>
                    )}
                  </a>
                </li>
              )}


            {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                     <li  style={{ position: "relative" }}>
                  <a
                    className={`${
                      menu == 7 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(7)}
                  >
                    My Messages
                  </a> 
                </li>
              )}


            {this.props.match &&
              this.props.match.params &&
              this.props.match.params.id &&
              this.props.user.profile._id === this.props.match.params.id && (
                <li  style={{ position: "relative" }}>
                  <a
                    className={`${
                      menu == 8 ? "profile_page_menu_option_active" : ""
                    }`}
                    onClick={() => this.selectMenu(8)}
                  >
                    My Knowledge Checks
                       {this.state.pendingKnowledgeChecksCount > 0 && (
                        <span className="tab_count kcs_tab_count">
                          {this.state.pendingKnowledgeChecksCount}
                        </span>
                      )}
                  </a>
                </li>
              )}


          </ul>
          )}
        </div>

        {this.renderProfileMenuContent()}

        <Modal
          isOpen={showEditProfileInfoModal}
          className="profile-info-modal bwai-profile-modal"
        >
          <ModalBody className="profile-modal-body">
            <Row className="mlmr0 bwai-modal-header">
              <span className="col-sm-6 col-md-6 profile-modal-heading-txt ">
                Edit Profile Information
              </span>
              <button
                type="button"
                className="bwai-modal-close"
                aria-label="Close"
                onClick={this.closeEditProfileInfoModal}
              >
                <LuX size={20} />
              </button>
            </Row>
            <Row className="mlmr0 mt30 bwai-modal-avatar-row">
              <Col
                sm={3}
                className="profile-modal-label align-self-center"
              ></Col>
              <Col sm={9}>
                <div className="img-container">
                  <img
                    src={
                      profilePic.profilePicUrl
                        ? profilePic.profilePicUrl
                        : profilePicValidityCheck(profilePic.value)
                          ? profilePic.value
                          : UserRobot1
                    }
                    className="user-profile-img"
                  />

                  <div className="middle">
                    <div className="text d-flex align-items-center justify-content-center">
                      <label
                        htmlFor="profile-pic-file-input"
                        style={{ marginBottom: "0px" }}
                      >
                        <span
                          className="cursor-pointer edit-txt "
                          style={{ color: "white" }}
                        >
                          edit
                        </span>
                      </label>
                      <input
                        id="profile-pic-file-input"
                        onChange={this.handleProfilePicUpload}
                        type="file"
                      />
                    </div>
                  </div>
                </div>
                {profilePic.error ? (
                  <div className="input-error-msg-field">
                    {profilePic.errorMessage}
                  </div>
                ) : null}

                <label className="changeProfilePic">
                  Change Profile Picture
                  <input
                    id="profile-pic-file-input"
                    type="file"
                    onChange={this.handleProfilePicUpload}
                  ></input>
                </label>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                First Name
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={firstName.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      firstName: {
                        updatedValue: event.target.value,
                        value: firstName.value,
                      },
                    });
                  }}
                  invalid={firstName.error}
                />
                {firstName.error ? (
                  <div className="input-error-msg-field">
                    {firstName.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Last Name
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={lastName.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      lastName: {
                        updatedValue: event.target.value,
                        value: lastName.value,
                      },
                    });
                  }}
                  invalid={lastName.error}
                />
                {lastName.error ? (
                  <div className="input-error-msg-field">
                    {lastName.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Mobile Number
              </Col>
              <Col sm={9}>
                <PhoneInput
                  placeholder="Enter mobile number"
                  value={mobileNumber.updatedValue}
                  addInternationalOption={false}
                  className="form-control p-0 pl-2"
                  defaultCountry="US"
                  onChange={(v) => {
                    this.setState({
                      mobileNumber: {
                        updatedValue: formatPhoneNumber(v),
                        value: mobileNumber.value,
                      },
                    });
                  }}
                  invalid={mobileNumber.error}
                />
                {mobileNumber.error ? (
                  <div className="input-error-msg-field">
                    {mobileNumber.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Email
              </Col>
              <Col sm={9}>
                <Input
                  type="email"
                  className="input-custom"
                  value={email.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      email: {
                        updatedValue: event.target.value,
                        value: email.value,
                      },
                    });
                  }}
                  invalid={email.error}
                />
                {email.error ? (
                  <div className="input-error-msg-field">
                    {email.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Employee ID
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={employeeId.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      employeeId: {
                        updatedValue: event.target.value,
                        value: employeeId.value,
                      },
                    });
                  }}
                  invalid={employeeId.error}
                />
                {employeeId.error ? (
                  <div className="input-error-msg-field">
                    {employeeId.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            {/* <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Title
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={title.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      title: {
                        updatedValue: event.target.value,
                        value: title.value,
                      },
                    });
                  }}
                  invalid={title.error}
                />
                {title.error ? (
                  <div className="input-error-msg-field">
                    {title.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row> */}


            {!isTrivvyUrl?
            <span>


            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Occupation</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select occupation"
                  value={
                    occupation.updatedValue
                      ? this.diversityValue(
                          occupation,
                          this.props.user.occupation,
                          "occupation"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={occupation.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, occupation)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Job Category
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select job category"
                  value={
                    seniority.updatedValue
                      ? this.diversityValue(
                          seniority,
                          this.props.user.seniority,
                          "seniority"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={seniority.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, seniority)}
                />
              </Col>
            </Row>

     
               

            <Alert color="info">
              <span className="alert-info-text">
                <span className="alert-info-icon"></span>
                {isTrivvyProduct() ? (
                  <span>
                    {" "}
                    Please self-identify below regarding your gender, ethnicity,
                    sexual orientation, veteran status, disability, age and
                    religion. This information is private to you, and is never
                    disclosed to other users, your employer or anyone else. It
                    is used only for purposes of understanding the demographics
                    of our users. You can edit the information at any time.
                  </span>
                ) : (
                  <span>
                    Please self-identify below regarding your gender, ethnicity,
                    sexual orientation, veteran status, disability, age and
                    religion. This information is private to you, and is never
                    disclosed to other users, your employer or anyone else. It
                    is used only for purposes of improving your own experience
                    on this platform, and creating anonymously aggregated
                    benchmarks to improve diversity, inclusion and belonging in
                    your organization. You can edit the information at any time.
                  </span>
                )}
              </span>
            </Alert>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Date of Birth
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <div className="inner-addon right-addon">
                  {/* <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("selectFileDate")} /> */}
                  <DatePicker
                    id="selectFileDate"
                    placeholderText="Enter birth date"
                    className="input-custom-date form-control"
                    showYearDropdown
                    onChange={this.handleDateChange}
                    selected={
                      birthDate.updatedValue
                        ? moment(birthDate.updatedValue)
                        : null
                    }
                    maxDate={moment()}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Gender</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select gender"
                  // value={this.diversityValue(gender)}
                  value={
                    gender.updatedValue
                      ? this.diversityValue(
                          gender,
                          this.props.user.gender,
                          "gender"
                        )
                      : null
                  }
                  // optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={gender.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, gender)}
                  // onChange={(event)=> this.setState({gender: { updatedValue: {value:event.target.value, label:event.target.value}}}) }
                />
              </Col>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Pronoun</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select gender pronoun"
                  value={genderPronoun.updatedValue}
                  clearable={false}
                  options={GENDER_PRONOUNS_OPTIONS}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) =>
                    this.setState({
                      genderPronoun: {
                        ...genderPronoun,
                        updatedValue: e.value,
                      },
                    })
                  }
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Ethnicity</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select ethnicity"
                  value={
                    ethnicity.updatedValue
                      ? this.diversityValue(
                          ethnicity,
                          this.props.user.ethnicity,
                          "ethnicity"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={ethnicity.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, ethnicity)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Sexual Orientation
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select sexual orientation"
                  value={
                    sexualOrientation.updatedValue
                      ? this.diversityValue(
                          sexualOrientation,
                          this.props.user.sexualOrientation,
                          "sexualOrientation"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={sexualOrientation.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, sexualOrientation)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Veteran Status
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select veteran type"
                  value={
                    veteran.updatedValue
                      ? this.diversityValue(
                          veteran,
                          this.props.user.veteran,
                          "veteran"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={veteran.options}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, veteran)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Disability</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select disability type"
                  value={
                    disability.updatedValue
                      ? this.diversityValue(
                          disability,
                          this.props.user.disability,
                          "disability"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={disability.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, disability)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Religion</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select religion"
                  value={
                    religion.updatedValue
                      ? this.diversityValue(
                          religion,
                          this.props.user.religion,
                          "religion"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={religion.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, religion)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Address (Location)
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <AutocompleteAddress
                  address={this.state.address.updatedValue}
                  handleSelect={(address, lng, lat) => {
                    this.setState({
                      address: { ...this.state.address, updatedValue: address },
                    });
                    this.setState({
                      location: {
                        ...this.state.location,
                        updatedValue: {
                          type: "Point",
                          coordinates: [lng, lat],
                        },
                      },
                    });
                  }}
                  relative
                  delayClose
                />
              </Col>
            </Row>

            </span>
            :
            null
            }       

            <Row className={`${isMobile && "mb30"}  mlmr0 mt30 bwai-modal-footer`}>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="profile-modal-save-btn"
                  onClick={this.handleEditProfileInfo}
                >
                  <span className="profile-modal-save-btn-txt">
                    {!isMobile && <span className="ml10 flaticon-tick"></span>}
                    {!isMobile ? "Save" : "Continue"}
                  </span>
                  {isMobile && (
                    <span className="ml10">
                      <img
                        className=""
                        style={{ height: "32px" }}
                        src={rightArrowImg}
                      />
                    </span>
                  )}
                </Button>
              </Col>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className={`${isMobile ? 'mt-3' : ''} profile-modal-cancel-btn`}
                  onClick={this.closeEditProfileInfoModal}
                >
                  <span className="profile-modal-cancel-btn-txt">Cancel</span>
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  };

  render() {
    return this.renderProfile();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateUserSuccess: (data) => dispatch(actionCreators.updateUserSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(Profile, axios)));
